import { tv } from 'tailwind-variants'

export const styles = tv({
  slots: {
    aside: 'h-full',
    nav: [
      'flex h-full flex-col overflow-hidden',
      'transition-all',
      'bg-white',
      'bg-linear-to-br from-white from-25% via-white via-35% to-[#E7F3FF]',
    ],
  },
  variants: {
    collapsed: {
      true: {
        aside: 'w-[48px]',
        nav: 'w-[48px]',
      },
      false: {
        aside: 'w-full md:w-[216px] lg:w-[240px]',
      },
    },
    collapsible: {
      true: {
        nav: [
          'hover:w-[216px] lg:hover:w-[240px]',
          'hover:bg-linear-to-br hover:from-white hover:from-25% hover:via-white hover:via-35% hover:to-[#E7F3FF]',
        ],
      },
      false: {},
    },
    hovered: {
      true: {
        nav: 'bg-linear-to-br from-white from-25% via-white via-35% to-[#E7F3FF]',
      },
      false: {},
    },
    rounded: {
      true: {
        nav: 'rounded-tr-2xl',
      },
      false: {},
    },
    settingsAsideScrollbar: {
      true: {},
      false: {},
    },
  },
  defaultVariants: {
    rounded: true,
    settingsAsideScrollbar: false,
  },
  compoundVariants: [
    {
      collapsed: true,
      collapsible: true,
      class: {
        nav: 'hover:shadow-[4px_0px_16px_rgba(0,0,0,0.08)]',
      },
    },
  ],
})
